import ClientsPage from "./pages/Clients";
import CelebrationsPage from "./pages/Celebrations";
import ProjectsPage from "./pages/Projects";
import SectorsPage from "./pages/Sectors";
import SalesPage from "./pages/Sales";
import TypologiesPage from "./pages/Typologies";
import LoginPage from "./pages/Login";
import PreviewsPage from "./pages/Previews";
import ProvidersPage from "./pages/Providers";
import AgencyPage from "./pages/Agencies";
import ProvidersExpertisePage from "./pages/ProvidersExpertise";
import { Routes, Route, Navigate } from "react-router-dom";
import ErrorPage from "./pages/404Error";
import FeedbackBandeau from "./components/Alert/AlertBandeau";

import { useAuth } from "./hooks/use-auth";
import { Container } from "./styles/App.styled";

const ProtectedRoute = ({ children, isLogged }) => {
  if (!isLogged) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default function Main() {
  const { isLogged } = useAuth();

  return (
    <Container component="main">
      <FeedbackBandeau />
      <Routes>
        <Route path="/previews" element={<PreviewsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/projects"
          element={
            <ProtectedRoute isLogged={isLogged}>
              <ProjectsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedRoute isLogged={isLogged}>
              <ClientsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/celebrations"
          element={
            <ProtectedRoute isLogged={isLogged}>
              <CelebrationsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sectors"
          element={
            <ProtectedRoute isLogged={isLogged}>
              <SectorsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales"
          element={
            <ProtectedRoute isLogged={isLogged}>
              <SalesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/typologies"
          element={
            <ProtectedRoute isLogged={isLogged}>
              <TypologiesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agencies"
          element={
            <ProtectedRoute isLogged={isLogged}>
              <AgencyPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/providers"
          element={
            <ProtectedRoute isLogged={isLogged}>
              <ProvidersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/providers-expertise"
          element={
            <ProtectedRoute isLogged={isLogged}>
              <ProvidersExpertisePage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Container>
  );
}
